export const desktopSizes = {
  lg: {
    width: 1350,
    height: 1280
  },
  md: {
    width: 1080,
    height: 1024
  },
  xs: {
    width: 675,
    height: 640
  }
};